import { GROUP_NAMES } from '@/modules/Events/constants';
import BaseModel from './base';
import Nomination from './nomination';

export const DEFAULT_NAME_GROUP = 'Основная категория';

export default class Group extends BaseModel {
  constructor(group, url) {
    super(group, url);
    this.name = group.name === GROUP_NAMES.default ? DEFAULT_NAME_GROUP : group.name;
    this.filters = group.filters; // тут привязка к аттрибутам
    this.attributes = group.attributes;

    this.nomination_id = group.nomination_id;
    this.nomination = group.nomination ? new Nomination(group.nomination) : null;
    this.event = group.event;

    this.ages = group.ages || null;

    this.parent_group_id = group.parent_group_id || '';
    this.created_at = group.created_at;
    this.updated_at = group.updated_at;
  }

  get isBaseCategory() {
    return this.name === DEFAULT_NAME_GROUP;
  }

  setAges(ages) {
    this.ages = ages || null;
  }
}
